import React from 'react'
import styles from "../../../CustomerDash/Components/schedulePOComps/Potable.module.css"

const VenOrderTable = () => {
    const data = [
        { id: 1, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' , subtotal: '40000'},
        { id: 2, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' , subtotal: '40000' },
        { id: 3, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' , subtotal: '40000' },
        { id: 4, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' , subtotal: '40000' },
    ];
    return (
        <div className={styles.previewContainer}>
            <table className={styles.previewtable}>
                <thead>
                    <tr>
                        <th className={styles.previewth} > Part #</th>
                        <th className={styles.previewth}>Manufacture</th>
                        <th className={styles.previewth} >Quantity</th>
                        <th className={styles.previewth} >Subtotal</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={item.id} className={styles.previewstripedRow}>
                            <td className={styles.previewtd} >
                                <div style={{ display: 'flex', gap: "6px" }}>
                                    <img src='/assets/Comparator.png' />
                                    <div>
                                        <a href=''>LM239DR2G</a> 
                                    </div>
                                </div>
                            </td>
                            <td className={styles.previewtd} >
                                <div>
                                    <a href=''>Bocsh</a> <br /><span>Linear Comparators</span>
                                </div>
                            </td>
                            <td className={styles.previewtd} >100</td>
                            <td className={styles.previewtd} >40000</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default VenOrderTable